<div class="form-check form-switch">
  <input
    class="form-check-input"
    type="checkbox"
    [checked]="active()"
    (change)="toggle($event)"
    (keydown.enter)="toggleOnEnter($any($event))"
    [attr.id]="id()"
    [disabled]="disabled() ? true : undefined"
  />
  <div
    class="toggle-tooltip"
    role="tooltip"
    [hidden]="!disabled()"
    [libTooltip]="textTooltip()"
  ></div>
  <label class="form-check-label" [attr.for]="id()">
    {{ active() ? textActive() : textInactive() }}
  </label>
</div>
